<template>
  <div
    v-style:c="captionColor"
    class="absolute right-0 z-1 mr-6"
    :class="[captionStyle, captionPosition === 'bottom' ? 'bottom-0 mb-3' : 'top-0 mt-3']"
    style="max-width: 9.375rem"
  >
    {{ captionText }}
  </div>
</template>

<script setup lang="ts">
import type { StyledCaption } from '#types/styles'

defineProps<StyledCaption>()
</script>
